import type { ReferencedEntity } from "@cohesive/api-client";
import { type Edge, Node } from "@xyflow/react";

export const selectedNodeCountSelector = (s: { nodes: Node[] }) =>
  s.nodes.filter((n) => n.selected).length;

/** Nodes eligible for multi-select layout toolbar actions (align, tidy, wrap in section). */
export function isMultiSelectToolbarNode(node: Node): boolean {
  return (
    !!node.selected &&
    node.type !== "chatSession" &&
    node.type !== "commentMarker" &&
    !(node.data as { loading?: boolean } | undefined)?.loading
  );
}

export const multiSelectNodesSelector = (s: { nodes: Node[] }) =>
  s.nodes.filter(isMultiSelectToolbarNode);

export const selectedEdgesSelector = (s: { edges: Edge[] }) =>
  s.edges.filter((e) => e.selected);

/** Equality for `useStore` selectors that return a fresh filtered array. */
export function shallowEqualArray<T>(
  a: readonly T[],
  b: readonly T[],
): boolean {
  if (a === b) return true;
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}

/** Equality for `useStore` selectors that return referenced-entity arrays. */
export function shallowEqualReferencedEntities(
  a: ReferencedEntity[],
  b: ReferencedEntity[],
): boolean {
  if (a === b) return true;
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
    const left = a[i];
    const right = b[i];
    if (
      left.entity_id !== right.entity_id ||
      left.entity_type !== right.entity_type ||
      left.name !== right.name ||
      left.platform !== right.platform
    ) {
      return false;
    }
  }
  return true;
}
